<template>

  <div class="quote-banner-container "  :style="{ backgroundImage: 'linear-gradient(rgba(236, 125, 2, .9), rgba(246, 168, 6, .7))' }">
  <!-- <div class="quote-banner-container"  :style="{ backgroundImage: 'linear-gradient(rgba(236, 125, 2, .9), rgba(246, 168, 6, .7)), url(' + url + ')' }"> -->

  <div class="container max-container">
      <div class="quote-profile-image">
        <img :src="profileOne" alt="">
      </div>
      <div class="quote-profile-text">
        <blockquote>
            <p class="quote"><slot name="content"></slot></p>
            <p class="person"><slot name="person"></slot></p>
        </blockquote>
      </div>
    </div>
  </div>


</template>

<script>
import { ref, onMounted, computed} from 'vue'
export default {

props: ['url', 'profileOne'],

setup(props) {

  // onMounted(() => {
  //   const link = document.querySelector('.quote-banner-container');

  //   link.style.backgroundImage = `linear-gradient(rgba(236, 125, 2, .9), rgba(246, 168, 6, .7)), url(${props.url})`;

  // })   

}

}
</script>

<style lang="scss" scoped>

   
</style>